import React, { Component } from 'react';
import { Result, Button, Typography } from 'antd';

const { Paragraph, Text } = Typography;

class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { error } = this.state;
      return (
        <div style={{ padding: 48 }}>
          <Result
            status="error"
            title="Something went wrong"
            subTitle="An unexpected error occurred. You can try reloading the page."
            extra={
              <Button type="primary" onClick={() => window.location.reload()}>
                Reload
              </Button>
            }
          >
            <details>
              <summary style={{ cursor: 'pointer', marginBottom: 8 }}>
                <Text strong>Error details</Text>
              </summary>
              <Paragraph copyable style={{ whiteSpace: 'pre-wrap' }}>
                {error && error.toString()}
                {error && error.stack ? '\n\n' + error.stack : ''}
              </Paragraph>
            </details>
          </Result>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
